import React from 'react';
import {join} from '../utils';
import styles from './icon.module.less';

class Props {
	toggled: boolean;
	color?: string;
}

export class ExpandIcon extends React.PureComponent<Props> {
	public override render() {
		return <div className='expand-icon'>{this.renderIcon()}</div>;
	}

	private renderIcon() {
		return <svg className={join(styles.expandIcon, this.props.toggled && styles.toggled)} width='10' height='6'
		            viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path d='M0 5.11133L5 -2.86102e-06L10 5.11133H0Z' fill={this.props.color ? this.props.color : '#828282'}/>
		</svg>;
	}
}
